export const config = {
    layoutConfig: {
        removeNav: false,
        removeFooter: false,
    },
    seo: {
        title: "2019冠狀病毒⾃我評估",
        description: "您有患上2019冠狀病毒的風險嗎？ 1分鐘評估2019冠狀病毒⾃我評估",
        ogImage: "",
    },
    questions: [
        {
            title: "您近2⽇內是否曾密切接觸(距離⼩於2⽶且時間超過15分鐘)或與2019新型冠狀病毒確診者同住?",
        },
        {
            title: "過去14天內，您有曾到訪有確診2019冠狀病毒病個案的的⼤廈、餐廳或地點? (詳情請參考衞⽣處最新資訊)",
        },
        {
            title: "最近14⽇內，您是否有外遊（包括所有香港以外地區）？",
        },
        {
            title: "呼吸困難或呼吸急促",
            icon: "self-test/covid/icon/icon01.png?1",
        },
        {
            title: "失去語⾔或⾏動能⼒，或混亂",
            icon: "self-test/covid/icon/icon02.png?1",
        },
        {
            title: "胸痛",
            icon: "self-test/covid/icon/icon03.png?1",
        },
        {
            title: "發燒（體溫⾼於38°C）",
            icon: "self-test/covid/icon/icon04.png?1",
        },
        {
            title: "持續咳嗽",
            icon: "self-test/covid/icon/icon05.png?1",
        },
        {
            title: "疲倦",
            icon: "self-test/covid/icon/icon06.png?1",
        },
        {
            title: "嗅覺喪失或味覺喪失",
            icon: "self-test/covid/icon/icon07.png?1",
        },
        {
            title: "喉嚨痛",
            icon: "self-test/covid/icon/icon08.png?1",
        },
        {
            title: "頭痛",
            icon: "self-test/covid/icon/icon09.png?1",
        },
        {
            title: "肌⾁疼痛或⾝體疼痛",
            icon: "self-test/covid/icon/icon10.png?1",
        },
        {
            title: "腹瀉",
            icon: "self-test/covid/icon/icon11.png?1",
        },
        {
            title: "⽪疹，或⼿指或腳趾變⾊",
            icon: "self-test/covid/icon/icon12.png?1",
        },
        {
            title: "眼睛發紅或發炎",
            icon: "self-test/covid/icon/icon13.png?1",
        },
    ],
    references: [
        {
            text: "港大及中大醫學院聯合研究發現已接種疫苗人士在感染新型冠狀病毒變異株Omicron後能對不同的新冠病毒變異株 產生更強烈和更廣泛的中和病毒抗體反應. (n.d.). Retrieved June 13, 2022, from",
            href: "https://sph.hku.hk/zh-HK/News-And-Events/Press-Releases/2022/HKUMed-CU-Medicine-joint-study-shows-that-vaccinated-individuals-develop-more-robust",
        },
        {
            text: "World Health Organization. (n.d.). Episode #64 - why are experts concerned about Omicron? World Health Organization. Retrieved June 13, 2022, from",
            href: "https://www.who.int/emergencies/diseases/novel-coronavirus-2019/media-resources/science-in-5/episode-64---why-are-experts-concerned-about-omicron?gclid=CjwKCAjwnZaVBhA6EiwAVVyv9KWbT5unxR-eASZfaRh3YDubSzpAKJyreEwDA1CP-2n_XWFlKb67sxoCbqEQAvD_BwE",
        },
        {
            text: "World Health Organization. (n.d.). Coronavirus. World Health Organization. Retrieved June 13, 2022, from",
            href: "https://www.who.int/health-topics/coronavirus#tab=tab_3",
        },
        {
            text: "Centre for Health Protection, Department of Health. (2022, April 8). 2019冠狀病毒防疫錦囊. Retrieved June 13, 2022, from",
            href: "https://www.coronavirus.gov.hk/pdf/tips_booklet.pdf",
        },
        {
            text: "Ferguson NM, Laydon D, Nedjati-Gilani G, et al, on behalf of the Imperial College COVID-19 Response Team. Impact of non-pharmaceutical interventions (NPIs) to reduce COVID19 mortality and healthcare demand.",
            href: "https://www.imperial.ac.uk/media/imperial-college/medicine/sph/ide/gida-fellowships/Imperial-College-COVID19-NPI-modelling-16-03-2020.pdf",
        },
        {
            text: "Mahase, E. (2021). Covid-19: Pfizer’s paxlovid is 89% effective in patients at risk of serious illness, company reports. BMJ.",
            href: "https://doi.org/10.1136/bmj.n2713",
        },
        {
            text: "2019冠狀病毒病第5波數據 Statistics on 5th Wave of COVID-19. (n.d.). Retrieved June 13, 2022, from",
            href: "https://www.covidvaccine.gov.hk/pdf/5th_wave_statistics.pdf",
        },
        {
            text: "曾德賢醫生 (n.d.). 新冠口服藥大減死亡風險 醫管局庫存充足 應付下一波疫情. Retrieved June 13, 2022, from",
            href: "https://www.ha.org.hk/haho/ho/pad/266890tc.pdf",
        },
    ]    
}
